import React from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

import Carousel from 'components/ui/carousel';
import { cdnURL } from 'components/utils/cdn';

import './styles.scss';

const Testimonials = () => {
  const testimonials = [
    { title: 'something out of love', message: 'Throughout the years, you have always reminded me of my friends’ upcoming birthdays unfailingly. You have made something out of love, and I would like to extend my gratitude to all of you over there for creating this wonderful, wonderful gem.', signature: 'Erica C' },
    { title: 'this is so convenient', message: 'I absolutely love this app. When I can’t personally go out and buy a card, this is so convenient!', signature: 'Rhonda C' },
    { title: 'My secret is Birthday Alarm', message: 'I must say I love the website and that my friends and family think I have an amazing memory as I remember to [send cards] on every occasion every year, without a miss. My secret is Birthday Alarm.', signature: 'Rakhi G' },
    { title: 'stupendous and esthetic', message: 'The variety of greetings available is stupendous and esthetic. I used to use 123 Greetings but now I find this is more sophisticated and innovative.', signature: 'Shali H' },
    { title: 'thank you guys', message: 'Just to thank you guys for your service – being in a nursing home and with cognitive issues, I would be at a loss remembering these important special days.', signature: 'Mark E' },
    { title: 'help us keep in touch', message: 'I would like to thank your company for helping me keep in touch with my friends. In these times when everyone is rushing; it is nice to have a company and its creators help us keep in touch.', signature: 'dvinjamoorie' },
    { title: 'better year after year', message: 'This site gets better year after year. Now that I am 77 it sure does help me to remember special days for my friends. thank you!', signature: 'Tim B' },
  ];

  return (
    <div className="testimonials">
      <Carousel
        dots
        infinite
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        adaptiveHeight
        nextArrow={<BsChevronRight/>}
        prevArrow={<BsChevronLeft/>}
      >
        {testimonials?.map((t, i) => (
          <div key={`testimonial-${i}`} className="testimonial">
            <img src={cdnURL('img/rebuild/promote/homepage/stars@2x.png')} width="161" height="29" alt="five star review"/>
            <h3>{t.title}</h3>
            <p>{t.message}</p>
            <p className="citation">- {t.signature}</p>
          </div>
        ))}
      </Carousel>
    </div>
  );
}

Testimonials.propTypes = {

};

Testimonials.defaultProps = {

};

export default Testimonials;
